// Copyright 2022 - 2023 Fewcha. All rights reserved.

export type StatsReducer = {
  rawPrice: string[];
  price: string[];

  maxSupply: number[];
  totalSupply: number[];
  remainingSupply: number[];
};

export const defaulStatsReducer: StatsReducer = {
  rawPrice: ["0", "0", "0", "0", "0", "0"],
  price: ["0", "0", "0", "0", "0", "0"],

  maxSupply: [0, 0, 0, 0, 0, 0],
  totalSupply: [0, 0, 0, 0, 0, 0],
  remainingSupply: [0, 0, 0, 0, 0, 0],
};

export type EventInfoResType = {
  price: string[];

  maxSupply: string[];
  totalSupply: number[];
};
